
import { ProcessTypeEnum, TenantUserModel } from '@/libs/Api';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import { Component, Prop, VModel, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class CategoryTypeSelect extends Vue {
    tenantUser: TenantUserModel = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;

    @VModel() innerValue!: string;
    @Prop({ default: '' }) label!: string;
    @Prop() type!: string | Array<string>;
    @Prop() readonly!: boolean;
    @Prop() rules!: [any[]];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) dense!: boolean;
    @Prop({ default: false }) noMarginTop!: boolean;
    @Prop({ default: false }) multiple!: boolean;
    @Prop({ default: false }) all!: boolean;
    @Prop({ default: true }) hideDetails!: boolean;
    @Prop({ default: true }) chips!: boolean;
    @Prop({ default: true }) clearable!: boolean;
    @Prop() placeholder!: string;
    @Prop() attach!: string;
    @Prop() except!: Array<string>;
    @Prop({ default: null }) processType!: ProcessTypeEnum | null;

    @Watch('innerValue')
    innerValueChanged(v: string) {
        this.$emit('change', v);
        this.$emit(
            'onSelect',
            this.items.firstOrDefault((x) => x.id == v)
        );
    }

    get items(): { id: ProcessTypeEnum; name: string }[] {
        return [
            { id: ProcessTypeEnum.Audit, name: this.$t('categories.processTypeAudit').toString() },
            { id: ProcessTypeEnum.Maintenance, name: this.$t('categories.processTypeMaintenance').toString() },
            { id: ProcessTypeEnum.Checklist, name: this.$t('categories.processTypeChecklist').toString() },
            { id: ProcessTypeEnum.IssueSolving, name: this.$t('categories.processTypeIssueSolving').toString() },
            { id: ProcessTypeEnum.ProductInspection, name: this.$t('categories.processTypeProductInspection').toString() },
        ];
    }
}
